import { Crown, Leaf } from "lucide-react";
import useBranding from "@/hooks/useBranding";
import { resolveImage } from "@/lib/image";

const iconSizes = {
  xs: "w-4 h-4",
  sm: "w-6 h-6",
  md: "w-8 h-8",
  lg: "w-10 h-10",
  xl: "w-12 h-12",
};

const imgSizes = {
  xs: "w-8 h-8",
  sm: "w-14 h-14",
  md: "w-16 h-16",
  lg: "w-24 h-24",
  xl: "w-36 h-36",
};

function pickLogo(branding, type) {
  switch (type) {
    case "header":
      return branding.header_logo;
    case "footer":
      return branding.footer_logo || branding.header_logo;
    case "admin":
      return branding.admin_logo || branding.header_logo;
    case "auth":
      return branding.login_logo || branding.header_logo;
    case "register":
      return branding.register_logo || branding.login_logo || branding.header_logo;
    case "restaurant":
      return branding.restaurant_logo || branding.header_logo;
    case "grocery":
      return branding.grocery_logo || branding.header_logo;
    case "customer":
      return branding.customer_logo || branding.header_logo;
    case "rewards":
      return branding.rewards_logo || branding.restaurant_logo || branding.header_logo;
    case "lechon":
      return branding.lechon_logo || branding.restaurant_logo || branding.header_logo;
    case "daily_menu":
      return branding.daily_menu_logo || branding.restaurant_logo || branding.header_logo;
    case "receipt":
      return branding.receipt_logo || branding.header_logo;
    default:
      return branding.header_logo;
  }
}

export default function BrandLogo({
  type = "header",
  src,
  label,
  sublabel,
  size = "md",
  variant = "dark",
  className = "",
  imageClassName = "",
  icon = "crown",
  showText = true,
  alt = "Maharlika",
}) {
  const { branding } = useBranding();
  const logo = src || pickLogo(branding, type);
  const finalLabel = label || branding.business_name || "Maharlika";
  const finalSublabel = sublabel || "Seafood Mart & Chow";

  const FallbackIcon = icon === "leaf" ? Leaf : Crown;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {logo ? (
        <div className="shrink-0 flex items-center justify-center">
          <img
            src={resolveImage(logo)}
            alt={alt || finalLabel}
            className={`${imgSizes[size] || imgSizes.md} object-contain ${imageClassName}`}
          />
        </div>
      ) : (
        <div className="shrink-0 flex items-center justify-center overflow-hidden rounded-full">
          <FallbackIcon
            className={`${iconSizes[size] || iconSizes.md} text-[#D4AF37]`}
            strokeWidth={1.5}
          />
        </div>
      )}

      {showText && (
        <div className="min-w-0">
          <div className="font-heading text-lg text-[#D4AF37] leading-none truncate">
            {finalLabel}
          </div>
          <div className="font-accent text-[9px] text-[#8A8A8A] tracking-[0.2em] uppercase truncate">
            {finalSublabel}
          </div>
        </div>
      )}
    </div>
  );
}
